import React, { useState, useContext, useEffect } from 'react';
import track from '../../lib/track'
import leadAttribution from '../../lib/attribution'
import { useForm, ValidationError } from '@formspree/react';
import './contactform.scss'
import checkicon from '../../images/checkicon.svg'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext';

function ContactForm() {
  const [state, handleSubmit] = useForm("myzkobag", { data: leadAttribution() });

  useEffect(() => {
    if (state.succeeded) track('quote_submitted', { form: 'contact' })
  }, [state.succeeded])
  const [selectedBudget, setSelectedBudget] = useState("");

  const { translations } = useContext(LanguageContext);


  if (state.succeeded) {
    return <div className="form-success-message">
    <img src={checkicon} alt="Success" className="success-icon" />
    <p className="success-text">{translations.contact1}</p>
    <p className="success-text">{translations.contact2}</p>

  </div>
  }

  const budgetOptions = [
    translations.contact3,
    "$10,000 - $50,000",
    "$50,000 - $100,000",
    "$100,000 - $250,000",
    translations.contact4,
  ];


  const handleCheckboxChange = (budget) => {
    setSelectedBudget(budget === selectedBudget ? "" : budget);
  };


  return (
    <form className='contact-form' onSubmit={handleSubmit}>
      <label htmlFor="name">{translations.contact5}</label>
      <input
        id="name"
        type="text"
        name="name"
        className='contact-form-input'
        required
      />

      <label htmlFor="email">
        {translations.contact6}
      </label>
      <input
        id="email"
        type="email"
        name="email"
        className='contact-form-input'
        required
      />
      <ValidationError
        prefix="Email"
        field="email"
        errors={state.errors}
      />

      <label htmlFor="phone">{translations.contact7}</label>
      <input
        id="phone"
        type="tel"
        name="phone"
        className='contact-form-input'
      />
      <ValidationError prefix="Phone" field="phone" errors={state.errors} />

      <div className="budget-checkbox-group">
        <p className="budget-title">{translations.contact8}</p>
        <div className="budget-checkbox-container">
          {budgetOptions.map((budget, index) => (
            <label key={index} className="budget-checkbox-label">
              <input
                type="checkbox"
                value={budget}
                checked={selectedBudget === budget}
                onChange={() => handleCheckboxChange(budget)}
              />
              {budget}
            </label>
          ))}
        </div>
      </div>

      <label htmlFor="message">
       {translations.contact9}
      </label>
      <textarea
        id="message"
        name="message"
        className='contact-form-input contact-form-textarea '
      />
      <ValidationError
        prefix="Message"
        field="message"
        errors={state.errors}
      />
      <button type="submit" className='contact-btn' disabled={state.submitting}>
        {translations.contact10}
      </button>
    </form>
  );
}

export default ContactForm